export enum DateInputSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum PickerPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum DateInputType {
  INPUT = 'input',
  PSEUDO = 'pseudo',
}

export interface DateInputProps {
  title?: string;
  placeholder?: string;
  value?: string;
  values?: string[];
  pickerPisition?: PickerPosition;
  onChange?: (date: Date) => void;
  onChangeRange?: (date: Date[]) => void;
  error?: string;
  borderless?: boolean;
  className?: string;
  size?: DateInputSize;
  bold?: boolean;
  type?: DateInputType;
  pickerClassName?: string;
  withoutCustomSelector?: boolean;
  disabled?: boolean;
  withoutTwoPickers?: boolean;
  onReset?: () => void;
  startDate?: Date;
  disabledAfter?: Date;
  tabIndex?: number;
  birthdayPicker?: boolean;
  withoutHidePlaceholder?: boolean;
  withValueReset?: boolean;
  formatDateLong?: boolean;
  withTitle?: boolean;
  withResetClose?: boolean;
  shortcuts?: React.JSX.Element;
  fullWidth?: boolean;
  withTime?: boolean;
  dateInputTitle?: string;
  withTimeSelector?: boolean;
  withoutIcon?: boolean;
  onTimeClick?: (data: boolean) => void;
}

export interface DateInputPrimaryTypes {
  datepickerVisible: boolean;
  setDatepickerVisible: (data: boolean) => void;
  title?: string;
  borderless?: boolean;
  inputValue?: string;
  placeholder?: string;
  disabled?: boolean;
  tabIndex?: number;
  focused?: boolean;
  setFocused: (data: boolean) => void;
  shortcuts?: React.JSX.Element;
  withTime?: boolean;
  withoutIcon?: boolean;
}

export interface DateInputPseudoTypes {
  datepickerVisible: boolean;
  setDatepickerVisible: (data: boolean) => void;
  title?: string;
  inputValue?: string;
  placeholder?: string;
  disabled?: boolean;
  tabIndex?: number;
  focused?: boolean;
  setFocused: (data: boolean) => void;
  withoutHidePlaceholder?: boolean;
  formatDateLong?: boolean;
  shortcuts?: React.JSX.Element;
  withTime?: boolean;
  withoutIcon?: boolean;
}
